export const FRAME_TYPE = {
  VIDEO_KEY: 0x01,

  VIDEO_DELTA: 0x02,

  AUDIO: 0x03,

  VIDEO_CONFIG: 4,

  CONFIG: 0x04,

  SCREENSHOT_CONFIG: 0x05,

  SERVER_ERROR: 0x06,

  RECONNECT_STATUS: 0x07,

  BROADCAST_STATS: 0x08,
} as const;
